module.exports = __webpack_public_path__ + "static/assetclassreturn3-9ea2876e57142a2e9e969601ff636ced.png";